'use strict';

var SoaModel = require('bunsen/models/SoaModel');
var SellerPaymentProfile = SoaModel.extend();
var endpoints = require('dibs-endpoints');
var _ = require('underscore');
var Seller = require('bunsen/models/Seller');

module.exports = SellerPaymentProfile;

_.extend(SellerPaymentProfile.prototype, {
    url: function () {
        var sellerId = this.findParent(Seller).id;
        return endpoints.sellerPaymentProfile(sellerId);
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/identity/SellerPaymentProfile.js
// module id = 2643
// module chunks = 64